import { useState, useEffect } from 'react';
import { getToken, getIsLoggedIn } from './session';

// Kept for backwards compatibility with callers that previously read from cookies.
// The token (sessionId) and the isLoggedIn flag now live in localStorage, detras
// de `services/session`.
function getCookie(name) {
  if (name === 'sessionId') return getToken();
  return getIsLoggedIn() ? 'true' : '';
}

function useAuthentication() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(getIsLoggedIn());
  });

  return [isLoggedIn];
}

const isLoggedIn = getIsLoggedIn();

export { useAuthentication, isLoggedIn, getCookie };
